// extracted by mini-css-extract-plugin
export default {"wrap":"Or-z","searchHeaderWrap":"Pr-z","melodyCategory":"Qr-z","fullWidth":"Rr-z","items":"Sr-z","featureCss":"Tr-z","disabled":"Ur-z","imgCss":"Vr-z"};